import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroAuth } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroAuth';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroBasicInfo } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroBasicInfo';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroContent } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroContent';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroMedia } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroMedia';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroSource } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroSource';

export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezero = {
  /** 인증 컨텍스트 정보 */
  auth?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroAuth;
  basicInfo?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroBasicInfo;
  /** 뉴스 내용 정보 */
  content?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroContent;
  /** 미디어 정보 */
  media?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroMedia;
  /** 뉴스 출처 정보 */
  source?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroSource;
};
